// @flow
import React from 'react';
export const WorkspaceUIContext = React.createContext({
    sidebarView: undefined,
    setSidebarView: () => ({}),
});
